<template>
  <div class="grid grid-rows-[auto_1fr] overflow-hidden">
    <ArbetsgivareHeader v-if="arbetsgivareStore.arbetsgivare.foretag" />
    <ContainerGrid scrollable>
      <MainColumn>
        <div
          class="custom-scrollbar mt-md overflow-y-scroll rounded-md bg-white"
        >
          <div v-if="!userProfileStore.hasArbetsgivareViewAccess">
            <p class="p-lg">
              Du har inte behörighet att se information om arbetsgivare.
            </p>
          </div>
          <template v-if="arbetsgivareStore.arbetsgivare.foretag">
            <div class="flex flex-col items-center justify-center">
              <div>
                <p class="p-lg">
                  {{ crmInfoText }}
                </p>
              </div>
            </div>
          </template>

          <div v-if="arbetsgivareStore.arbetsgivare.error">
            <p><strong>Misslyckades att hämta data</strong></p>
            <p>{{ arbetsgivareStore.arbetsgivare.error.title }}</p>
            <p>{{ arbetsgivareStore.arbetsgivare.error.errors }}</p>
            <p>{{ arbetsgivareStore.arbetsgivare.error.status }}</p>
            <p>{{ arbetsgivareStore.arbetsgivare.error.detail }}</p>
          </div>
          <div v-if="arbetsgivareStore.arbetsgivare.isLoading">
            <avtalat-spinner big />
          </div>
        </div>
      </MainColumn>
      <SidebarColumn v-if="userProfileStore.hasArbetsgivareViewAccess">
        <RightSideBar />
      </SidebarColumn>
    </ContainerGrid>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from "vue";

import { useApi } from "@/composables/useApi";
import { useConfirmNavigation } from "@/composables/useConfirmNavigation";
import { useNavigation } from "@/composables/useNavigation";
import { ContainerGrid, MainColumn, SidebarColumn } from "@/layout";
import { useUserProfileStore } from "@/stores";

import ArbetsgivareHeader from "./ArbetsgivareHeader.vue";
import RightSideBar from "./RightSideBar.vue";
import { useArbetsgivareStore } from "./store";

const navigation = useNavigation();
useConfirmNavigation();

const apiClient = useApi();
const userProfileStore = useUserProfileStore();
const arbetsgivareStore = useArbetsgivareStore();

const getArbetsgivare = async () => {
  await arbetsgivareStore.fetchArbetsgivare(
    navigation.currentRoute.query.organisationsnummer as string,
    apiClient,
  );
};

onMounted(async () => {
  if (!userProfileStore.hasArbetsgivareViewAccess) {
    return;
  }

  await getArbetsgivare();
});

onBeforeUnmount(() => {
  arbetsgivareStore.$reset();
});

const crmInfoText = computed(() =>
  arbetsgivareStore.arbetsgivare.foretag?.crmUrl
    ? "Mer information om arbetsgivaren finns för nuvarande i CRM."
    : "Nytt företag. Information om arbetsgivaren finns inte i CRM.",
);
</script>
